import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=710393c9&scoped=true&lang=pug&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=710393c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710393c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('710393c9')) {
      api.createRecord('710393c9', component.options)
    } else {
      api.reload('710393c9', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=710393c9&scoped=true&lang=pug&", function () {
      api.rerender('710393c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/virtualrowFSFB/components/Header.vue"
export default component.exports